export var Size;

(function (Size) {
  Size[Size["Xxxs"] = 0.25] = "Xxxs";
  Size[Size["Xxs"] = 0.5] = "Xxs";
  Size[Size["Xs"] = 0] = "Xs";
  Size[Size["Sm"] = 1] = "Sm";
  Size[Size["Md"] = 2] = "Md";
  Size[Size["Lg"] = 3] = "Lg";
  Size[Size["Xl"] = 4] = "Xl";
  Size[Size["Xxl"] = 5] = "Xxl";
})(Size || (Size = {}));